import { ProgramAvailablity } from "src/enums";
import { ReduxAction, TvModel, TvModelInitialState } from "../models";
import { TvTypes } from "../types";

export const TvState = (state: TvModel = TvModelInitialState, action?: ReduxAction): TvModel => {
    if (!action) return state;

    switch (action.type) {

        case TvTypes.SHOW_CHANNELS_LOADING:
        case TvTypes.REQUEST_CHANNEL_LIST:
            return { ...state, channelsLoading: true };
        case TvTypes.HIDE_CHANNELS_LOADING:
            return { ...state, channelsLoading: false };
        case TvTypes.SET_CHANNEL_LIST:
            return { ...state, channelsLoading: false, channels: action.payload || [] };

        case TvTypes.SHOW_TV_CONDUCTOR_LOADING:
            return { ...state, conductorLoading: true };
        case TvTypes.HIDE_TV_CONDUCTOR_LOADING:
            return { ...state, conductorLoading: false };
        case TvTypes.SET_TV_CONDUCTOR_SEARCH_TEXT:
            return { ...state, searchText: action.payload };
        case TvTypes.SET_TV_CONDUCTOR_CURRENR_DATE:
            return { ...state, currentDate: action.payload, conductor: [] };
        case TvTypes.SET_TV_CONDUCTOR_CURRENR_CHANNEL:
            return { ...state, currentChannel: action.payload, conductor: [], currentDate: undefined, episode: undefined };
        case TvTypes.REQUEST_TV_CONDUCTOR_LIST:
            const { date, text } = action.payload;
            return { ...state, searchText: text, currentDate: date, conductorLoading: true };
        case TvTypes.SET_TV_CONDUCTOR_LIST:
            return { ...state, conductor: action.payload || [], conductorLoading: false };
        case TvTypes.SHOW_TV_CONDUCTOR:
            return { ...state, showConductor: true };
        case TvTypes.HIDE_TV_CONDUCTOR:
            return { ...state, showConductor: false };
        case TvTypes.TOGGLE_TV_CONDUCTOR:
            return { ...state, showConductor: !state.showConductor };

        case TvTypes.SET_TV_STATUS:
            return { ...state, availability: action.payload };
        case TvTypes.SET_TV_MESSAGE:
            return { ...state, message: action.payload };
        case TvTypes.CLEAR_TV_MESSAGE:
            return { ...state, message: { hasMessage: false } };

        case TvTypes.SET_STREAM_URL:
            return { ...state, player: action.payload, availability: ProgramAvailablity.Available, killSessionId: action.payload ? [] : state.killSessionId };
        case TvTypes.START_TV_PLAYBACK_REPORTING:
            return { ...state, reporting: true };
        case TvTypes.STOP_TV_PLAYBACK_REPORTING:
            return { ...state, reporting: false };
        case TvTypes.SET_TV_OTHER_SESSIONS:
            return { ...state, killSessionId: action.payload };

        case TvTypes.SET_TV_CURRENT_EPISODE:
            return { ...state, episode: action.payload, };

    }

    return state;
};
